import React from 'react';
import { Typography, Box, Divider } from '@fullstory/components';
import { FormattedMessage } from 'react-intl';
export const EmptyNotifications: React.FC = () => (
  <>
    <Box padding={40}>
      <Typography variant="body1" textAlign="center">
        <FormattedMessage defaultMessage="You have no notifications" id="vxfDAp" />
      </Typography>
    </Box>
    <Divider />
    <Box padding={40}>
      <Typography variant="body2" textAlign="center">
        <FormattedMessage
          defaultMessage="Know when your segments are succeeding or struggling with the ability to create custom alerts."
          id="a2/dId"
        />
      </Typography>
    </Box>
  </>
);
